import { SearchSlotsResponse } from '@cemex-core/cmx-api';
import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import { SlotActionTypes, SlotsActions } from '../actions/slots.actions';
import * as moment from 'moment';

export interface SlotsState {
  loading: boolean;
  response: SearchSlotsResponse;
  fetched: boolean;
  availableDate: moment.Moment | null;
  availableSchedule: boolean;
  waitingListDefaulted: boolean;
  error: any;
}

export const initialState: SlotsState = {
  loading: false,
  response: null,
  fetched: false,
  availableDate: null,
  availableSchedule: false,
  waitingListDefaulted: false,
  error: null,
};

export function reducer(state = initialState, action: SlotsActions | OrderBuilderActions): SlotsState {
  switch (action.type) {
    case SlotActionTypes.LOAD_SLOTS_OP:
    case SlotActionTypes.LOAD_SLOTS: {
      return {
        ...state,
        response: null,
        fetched: false,
        loading: true,
        error: null,
      } as SlotsState;
    }
    case SlotActionTypes.LOAD_SLOTS_COMPLETED: {
      return {
        ...state,
        availableSchedule: !!action.payload.concreteProposals.length,
        response: action.payload,
        fetched: true,
        loading: false,
        error: null,
      } as SlotsState;
    }
    case SlotActionTypes.ERROR: {
      return {
        ...initialState,
        availableSchedule: false,
        fetched: true,
        error: action.payload,
      };
    }
    case RESET_BUILDER:
    case SlotActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    case SlotActionTypes.SLOT_AVAILABLE: {
      return {
        ...state,
        availableDate: action.payload,
      } as SlotsState;
    }
    case SlotActionTypes.SLOT_WAITING_LIST_DEFAULTED: {
      return {
        ...state,
        waitingListDefaulted: action.payload,
      } as SlotsState;
    }
    default: {
      return state;
    }
  }
}
